import {
  SET_CONVERSATIONS,
  SET_CURRENT_CONVERSATION,
  SET_PAGINATION_CONVERSATIONS,
  SET_DATA_CURRENT_CONVERSATION,
  SET_MESSAGES_HISTORY,
  SET_PAGINATION_MESSAGES_HISTORY,
  SET_BABY_ID,
  RESET_CHAT,
  SET_IS_SCROLL_TO_BOTTOM_LIST_CHAT,
  SET_LOADING_SCREEN_CHAT,
} from 'store/types/chat';

const initialState = {
  conversations: [],
  currentConversation: null,
  paginationConversations: { page: 1, page_size: 50, total: 0 },
  dataCurrentConversation: null,
  messagesHistory: [],
  paginationMessagesHistory: { page: 1, page_size: 50, total: 0 },
  babyId: null,
  isScrollToBottomListChat: false,
  loadingScreenChat: false,
};

const childrenReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONVERSATIONS:
      return {
        ...state,
        conversations: action?.payload,
      };
    case SET_CURRENT_CONVERSATION:
      return {
        ...state,
        currentConversation: action?.payload,
      };
    case SET_PAGINATION_CONVERSATIONS:
      return {
        ...state,
        paginationConversations: action?.payload,
      };
    case SET_DATA_CURRENT_CONVERSATION:
      return {
        ...state,
        dataCurrentConversation: action?.payload,
      };
    case SET_MESSAGES_HISTORY:
      return {
        ...state,
        messagesHistory: action?.payload,
      };
    case SET_PAGINATION_MESSAGES_HISTORY:
      return {
        ...state,
        paginationMessagesHistory: action?.payload,
      };
    case SET_BABY_ID:
      return {
        ...state,
        babyId: action?.payload,
      };
    case SET_IS_SCROLL_TO_BOTTOM_LIST_CHAT:
      return {
        ...state,
        isScrollToBottomListChat: action?.payload,
      };
    case SET_LOADING_SCREEN_CHAT:
      return {
        ...state,
        loadingScreenChat: action?.payload,
      };
    case RESET_CHAT:
      return initialState;
    default:
      return state;
  }
};

export default childrenReducer;
